// catch vite preload errors early
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault(); // prevent the error from being thrown further
  console.error('Vite preload error, reloading...', event);
  window.location.reload();
});

import 'core-js';
import 'regenerator-runtime/runtime';
import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { DEPLOYMENT } from 'config';

//eslint-disable-next-line
console.log(`%c Loading v${__APP_VERSION__} (${DEPLOYMENT})`, 'font-size:12px; font-weight:bold; color:green;');

startTransition(() => {
  hydrateRoot(document, <HydratedRouter />);
});
